import React from 'react';
import { FormGroup as LocalFormGroup } from 'components/common/Forms';
import {Modal, ModalBody, Button, ModalFooter, ModalHeader} from 'reactstrap';
import { compose, withHandlers, withState, withPropsOnChange } from 'recompose';
import {
 TableDataFetch
, DateRange
, withDateRange
, withTable
, TableSearch
, TableCSVExport
, ReducedTableCSVExport
, SearchFilterList
, SortList
, JobTypeFilterList
, JobSubSubStatusFilter} from 'components/common/Tables';
import {
  Page,
  PendingButton,
  withModal,
  withDebug,
  withResolver,
  NextPrevButtons,
  LoadingSpinner,
} from 'components/common';
import ReactPaginate from 'react-paginate';
import OrdersItem from './OrdersItem';
import { without, range } from 'lodash';
import { NotificationManager } from 'react-notifications';
import { updateIn } from 'icepick';
import _ from 'lodash';
import moment from 'moment';
import { RADIUS_ADMIN, INSTALLER } from 'permissions';
import { CSVImport, JobStatusTemplate } from 'components/common/JobStatusUpdate';
import DatePicker from "react-datepicker";
import SubJobStatusFilter from '../Orders/SubJobStatusFilter';
import FormGroup from '../../components/common/Forms/FormGroup';
import { Control } from 'react-redux-form';


const List = ({
  url = 'installer-orders',
  showCompletedAt = false,
  showOrderStatus = true,
  page,
  setPage,
  pages,
  ordering,
  data,
  setData,
  limit,
  openItem,
  toggleCollapse,
  search,
  setSearch,
  setFilters,
  setTempFilters,
  filters,
  tempFilters,
  installers,
  saveInstaller,
  saveEnabled,
  onInstallerChange,
  refresh,
  setRefresh,
  title,
  comments,
  setComment,
  updateResults,
  rejectAllPending,
  acceptAllPending,
  onDoAll,
  toggleModal,
  acceptReject,
  setAcceptReject,
  isModalOpen,
  canAccept,
  canManage,
  canView,
  canChangeStatus,
  rejectionReasons,
  reason,
  setReason,
  jobStatuses,
  onStatusChange,
  onDateChange,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  role,
  client,
  searchTerm,
  setSearchTerm,
  hasSearchBeenClicked,
  setHasSearchBeenClicked,
  isLoading,
  setIsLoading,
  onBookedDateChange,
  toggleBookedDateModal,
  isBookedDateModalOpen,
  setIsBookedDateModalOpen,
  onCompletedDateChange,
  toggleCompletedDateModal,
  isCompletedDateModalOpen,
  setIsCompletedDateModalOpen,
  idx,
  jobIdx,
  appointment_date,
  job_completed_at,
  job_status,
  isSubStatus,
  jobSubStatusOptions,
  onJobSubStatusChange,
  setJobSubStatus,
  jobSubStatus,
  jobCompletedDate,
  jobSubStatuses,
  toggleSubStatusModal,
  isSubStatusModalOpen,
  setIsSubStatusModalOpen,
  jobSubStatusesFilter
}) => (
  <Page title={title}>
  {isBookedDateModalOpen && (
      <Modal isOpen={isBookedDateModalOpen} toggle={toggleBookedDateModal} keyboard={false} backdrop="static">
        <ModalHeader>
          Select Booked Date
        </ModalHeader>
        <ModalBody>
          <DatePicker
              className="form-control"
              value={appointment_date && moment(appointment_date).format('YYYY-MM-DD')}
              onChange={v => onBookedDateChange(idx, jobIdx, v.format('YYYY-MM-DD'))}
              dateFormat="YYYY-MM-DD"
              required={job_status == "Installation Booked"}
          />
        </ModalBody>
      </Modal>
  )}
  {isCompletedDateModalOpen && (
      <Modal isOpen={isCompletedDateModalOpen} toggle={toggleCompletedDateModal} keyboard={false} backdrop="static">
        <ModalHeader>
          Select Completed Date
        </ModalHeader>
        <ModalBody>
          <DatePicker
              className="form-control"
              value={jobCompletedDate && moment(jobCompletedDate).format('YYYY-MM-DD')}
              onChange={v => onCompletedDateChange(idx, jobIdx, v.format('YYYY-MM-DD'))}
              dateFormat="YYYY-MM-DD"
              required={job_status == "Installation Complete"}
          />
        </ModalBody>
        {isSubStatus && (
          <React.Fragment>
            <ModalHeader>
              Select Job Status Detail
            </ModalHeader>
            <ModalBody>
              <FormGroup model=".job_substatus">
                <Control.select
                  model=".job_substatus"
                  onChange={onJobSubStatusChange}
                >
                  <option value="" disabled selected hidden>
                    Select Job Status Detail
                  </option>
                  {jobSubStatusOptions.map(i => (
                    <option key={i.value} value={i.value}>
                      {i.text}
                    </option>
                  ))}
                </Control.select>
              </FormGroup>
            </ModalBody>
          </React.Fragment>
        )}
    </Modal>
  )}

  {isSubStatusModalOpen && (
      <Modal isOpen={isSubStatusModalOpen} toggle={toggleSubStatusModal} keyboard={false} backdrop="static">
        <ModalHeader>
          Select Job Status Detail
        </ModalHeader>
        <ModalBody>
        <FormGroup model=".job_substatus">
          <Control.select
            model=".job_substatus"
            onChange={onJobSubStatusChange}
        >
        <option value="" disabled selected hidden>
          Select Job Status Detail
        </option>
        {jobSubStatusOptions.map(i => (
          <option key={i.value} value={i.value}>
            {i.text}
          </option>
        ))}
      </Control.select>
      </FormGroup>
      </ModalBody>
      </Modal>
    )}

    <div className='d-flex justify-content-between align-items-stretch'>
      <SearchFilterList filters={tempFilters} setFilters={setTempFilters}/>
      {/*<TableSearch onChange={
        (e) => {
          setFilters({
            ...filters,
            offset: 0,
          });
          setSearch(e)
        }
      } value={search}/>*/}
      <TableSearch onChange={
          (e) => {
            setSearchTerm(e);
            console.log("TableSearch changed.");
          }
        }
        onKeyUp={e => {
          e.preventDefault();
          if(e.keyCode === 13){
            console.log({tempFilters});
            setFilters(tempFilters);
            setSearch(searchTerm);
            setHasSearchBeenClicked(true);
            setIsLoading(true);
          }
        }}
        value={searchTerm}
      />

      {/*<button
        className="mb-4 mt-2 form-control-sm"
        style={{ "border":"1px solid #dee2e6", "backgroundColor":"#fff" }}
        onClick={() => {
          console.log({tempFilters});
          setFilters(tempFilters);
          setSearch(searchTerm);
          setHasSearchBeenClicked(true);
          setIsLoading(true);
        }}
      >Search</button>*/}

      <Button
        color="primary"
        className="mb-3 mt-2 px-4"
        onClick={() => {
          console.log({tempFilters});
          setRefresh(moment());
          setFilters(tempFilters);
          setSearch(searchTerm);
          setHasSearchBeenClicked(true);
          setIsLoading(true);
        }}
      >Search</Button>

    </div>
    <div className='d-flex flex-wrap justify-content-left'>
      { (title === "Completed Jobs" || title === "Assigned Orders" || title === "Unassigned Orders" || title === "All Orders") &&
        <DateRange
          fromDate={fromDate}
          toDate={toDate}
          onFromDateChange={setFromDate}
          onToDateChange={setToDate}
          dateFormat={'YYYY-MM-DD'}
          filters={tempFilters}
          setFilters={setTempFilters}
        />
      }
      <div className='mr-4'>
        <JobTypeFilterList
          filters={tempFilters}
          setFilters={setTempFilters}
        />
      </div>
      <div className='mr-4'>
      {SubJobStatusFilter(title, tempFilters, setTempFilters) }
      </div>
      {(title === "Assigned Orders" || title === "Completed Jobs" || title === "All Orders") && (
    <div className='mr-4'>
      <JobSubSubStatusFilter options={jobSubStatusesFilter} filters={tempFilters} setFilters={setTempFilters} />
    </div>
      )}
      <div>
        <SortList filters={tempFilters} setFilters={setTempFilters}/>
      </div>
    </div>
    {canAccept && (
      <div className="clearfix">
        <PendingButton
          disabled={!data.results.length}
          onClick={(e) => {
            setAcceptReject('reject');
            toggleModal();
          }}
          color="danger"
          className="ml-2 float-right mb-1"
        >
          Reject All
        </PendingButton>
        <PendingButton
          disabled={!data.results.length}
          onClick={(e) => {
            setAcceptReject('accept');
            toggleModal();
          }}
          color="success"
          className="float-right mb-1"
        >
          Accept All
        </PendingButton>
      </div>
    )}
    { data.count != 0 &&
      <ReactPaginate
        pageCount={data.count / limit}
        forcePage={page}
        marginPagesDisplayed={2}
        pageRangeDisplayed={15}
        breakClassName="page-item"
        breakLabel={<a className="page-link">...</a>}
        pageClassName="page-item"
        previousClassName="page-item"
        nextClassName="page-item"
        pageLinkClassName="page-link"
        previousLinkClassName="page-link"
        nextLinkClassName="page-link"
        nextLabel={'next'}
        previousLabel={'previous'}
        breaklabel={'...'}
        containerClassName={'pagination no-margin pull-right mb-0'}
        subContainerClassName={'page-item pagination no-margin pull-right mb-0'}
        activeClassName={'active'}
        onPageChange={({selected}) => {
          window.scroll(0,0);
          setPage(selected);
          setFilters({
            ...tempFilters,
            offset: selected <= 0 ? 0 : (selected) * limit,
          });
        }}
      />
    }
    <br/><br/>

    {!!isLoading && (
      <LoadingSpinner/>
    )}

    {data.results.map((x, idx) => (
      <OrdersItem
        key={x.id}
        item={x}
        client={client}
        open={openItem === x.id}
        onInstallerReplied={() => updateResults(without(data.results, x))}
        updateResults={updateResults}
        rejectionReasons={rejectionReasons}
        toggleCollapse={toggleCollapse}
        saveEnabled={true}
        canManage={canManage}
        canView={canView}
        canAccept={canAccept}
        //        jobStatuses={jobStatuses}
        subStatuses={jobSubStatuses}
        onStatusChange={(jobIdx, value) => onStatusChange(idx, jobIdx, value)}
        onDateChange={(jobIdx, value) => onDateChange(idx, jobIdx, value)}
        showCompletedAt={showCompletedAt}
        showOrderStatus={showOrderStatus}
        canChangeStatus={canChangeStatus}
        setRefresh={setRefresh}
        onBookedDateChange={(jobIdx, value) => onBookedDateChange(idx, jobIdx, value)}
        toggleBookedDateModal={toggleBookedDateModal}
        isBookedDateModalOpen={isBookedDateModalOpen}
        setIsBookedDateModalOpen={setIsBookedDateModalOpen}
        onCompletedDateChange={(jobIdx, value) => onCompletedDateChange(idx, jobIdx, value)}
        toggleCompletedDateModal={toggleCompletedDateModal}
        isCompletedDateModalOpen={isCompletedDateModalOpen}
        setIsCompletedDateModalOpen={setIsCompletedDateModalOpen}
        toggleSubStatusModal={toggleSubStatusModal}
        isSubStatusModalOpen={isSubStatusModalOpen}
        setIsSubStatusModalOpen={setIsSubStatusModalOpen}
      />
    ))}
    { data.count != 0 &&
      <ReactPaginate
        pageCount={data.count / limit}
        forcePage={page}
        marginPagesDisplayed={2}
        pageRangeDisplayed={15}
        breakClassName="page-item"
        breakLabel={<a className="page-link">...</a>}
        pageClassName="page-item"
        previousClassName="page-item"
        nextClassName="page-item"
        pageLinkClassName="page-link"
        previousLinkClassName="page-link"
        nextLinkClassName="page-link"
        nextLabel={'next'}
        previousLabel={'previous'}
        breaklabel={'...'}
        containerClassName={'pagination no-margin pull-right mb-0'}
        subContainerClassName={'page-item pagination no-margin pull-right mb-0'}
        activeClassName={'active'}
        onPageChange={({selected}) => {
          window.scroll(0,0);
          setPage(selected);
          setFilters({
            ...tempFilters,
            offset: selected <= 0 ? 0 : (selected) * limit,
          });
        }}
      />
    }
    <br/><br/>
    {(role === RADIUS_ADMIN || role === INSTALLER) && (
        (title !== "All Orders") &&
      <div>
        <TableCSVExport
          ordering={ordering}
          refreshToken={refresh}
          limit={limit}
          filters={filters}
          url={url}
          search={search}
          filename={date => `orders_${date}.csv`}
          client={client}
          offset={0}
        />

        <ReducedTableCSVExport
          ordering={ordering}
          refreshToken={refresh}
          limit={limit}
          filters={filters}
          url={url}
          search={search}
          filename={date => `orders_${date}.csv`}
          client={client}
          offset={0}
        />
        <CSVImport
            client={client}
            setRefresh={setRefresh}
            setIsLoading={setIsLoading}
            setHasSearchBeenClicked={setHasSearchBeenClicked}
            subStatuses={jobSubStatuses}
        />
        <JobStatusTemplate
            ordering="jobs.id"
            refreshToken={refresh}
            limit={999999}
            filters={filters}
            url={url}
            search={search}
            filename="jobstatuses.csv"
            client={client}
            offset={0}
        />
      </div>
    )}
    {!!hasSearchBeenClicked && (
      <TableDataFetch
        ordering={ordering}
        refreshToken={refresh}
        limit={limit}
        filters={filters}
        url={url}
        search={search}
        onDataFetched={setData}
        onLoaded={setIsLoading}
      />
    )}

    {isModalOpen && (
      <Modal isOpen={isModalOpen} toggle={toggleModal}>
        <ModalBody>
            Are you sure you want to {acceptReject} all of the orders?
            {acceptReject == 'reject' &&
              <LocalFormGroup label="Reason:">
                <select
                  onChange={e => setReason(e.target.value)}
                  className="form-control"
                >
                  {rejectionReasons.map(i => (
                    <option key={i.value} value={i.value}>
                      {i.text}
                    </option>
                  ))}
                </select>
              </LocalFormGroup>
            }
        </ModalBody>
        <ModalFooter>
          {acceptReject === 'accept' ?
            <PendingButton
              color="primary"
              pending={acceptAllPending}
              onClick={onDoAll}
            >
              Confirm
            </PendingButton> :
            <PendingButton
              color="primary"
              pending={rejectAllPending}
              onClick={onDoAll}
            >
              Confirm
            </PendingButton>
          }
          {' '}
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    )}
  </Page>
);

const enhance = compose(
  withTable({ limit: 5}),
  withState('idx', 'setIdx', null),
  withState('jobIdx', 'setJobIdx', null),
  withState('job_status', 'setJobStatus', null),
  withState('comments', 'setComments', {}),
  withState('openItem', 'setOpenItem', null),
  withState('refresh', 'setRefresh', false),
  withState('acceptReject', 'setAcceptReject', 'accept'),
  withState('rejectAllPending', 'setRejectAllPending', false),
  withState('acceptAllPending', 'setAcceptAllPending', false),
  //  withState('jobStatuses', 'setJobStatuses', null),
  withState('rejectionReasons', 'setRejectionReasons', []),
  withState('reason', 'setReason', 1),
  withModal(),
  withState('filters', 'setFilters', {search_filter:'order_ref',jobtype_filter:999}),
  withState('tempFilters', 'setTempFilters', {search_filter:'order_ref',jobtype_filter:999}),
  withState('searchTerm', 'setSearchTerm', ''),
  withState('isLoading', 'setIsLoading', false),
  withState('hasSearchBeenClicked', 'setHasSearchBeenClicked', false),
  withState('jobSubStatuses', 'setJobSubStatuses', null),
  withState('jobSubStatusOptions', 'setJobSubStatusOptions', []),
  withState('isSubStatus', 'setIsSubStatus', false),
  withState('jobSubStatus', 'setJobSubStatus', null),
  withState('jobSubStatusesFilter', 'setJobSubStatusesFilter', []),
  withState('jobCompletedDate', 'setJobCompletedDate', null),
  withDateRange(),
  withPropsOnChange(['defaultFilters', 'filters'], ({defaultFilters, filters}) => {
    return { filters: {...defaultFilters, ...filters} }
  }),
  withHandlers({
    updateItem: ({ data, updateResults }) => (idx, path, cb) => {
      updateResults(updateIn(data.results, [idx, ...path], cb));
    },
  }),
  withState('isBookedDateModalOpen','setIsBookedDateModalOpen',false),
  withState('isCompletedDateModalOpen','setIsCompletedDateModalOpen',false),
  withState('isSubStatusModalOpen','setIsSubStatusModalOpen',false),
  withState('appointment_date','setAppointmentDate',false),
  withState('job_completed_at','setJobCompletedAt',false),
  withHandlers({
    toggleBookedDateModal: ({isBookedDateModalOpen, setIsBookedDateModalOpen}) => () => {
      setIsBookedDateModalOpen(!isBookedDateModalOpen);
    },
  }),
  withHandlers({
    toggleCompletedDateModal: ({isCompletedDateModalOpen, setIsCompletedDateModalOpen}) => () => {
      setIsCompletedDateModalOpen(!isCompletedDateModalOpen);
    },
  }),
  withHandlers({
    toggleSubStatusModal: ({isSubStatusModalOpen, setIsSubStatusModalOpen}) => () => {
      setIsSubStatusModalOpen(!isSubStatusModalOpen);
    },
  }),
  withHandlers({
    onBookedDateChange: ({ client, data, updateItem, setIsBookedDateModalOpen }) => (
        idx,
        jobIdx,
        appointment_date
    ) => {
      const order = data.results[idx];
      const job = order.jobs[jobIdx];

      client.patch(`installer-jobs/${job.id}`, { appointment_date }).tap(() => {
        updateItem(idx, ['jobs', jobIdx, 'appointment_date'], () => appointment_date);
        NotificationManager.success('Appointment date updated');
      });
      setIsBookedDateModalOpen(false);
    },
  }),
  withHandlers({
    onCompletedDateChange: ({ 
      setJobCompletedAt,
      client, 
      data, 
      updateItem, 
      setIsCompletedDateModalOpen, 
      isSubStatus, 
      jobSubStatus,
      setJobSubStatus,
      setJobCompletedDate,
    }) =>(
      idx,
      jobIdx,
      job_completed_at
    ) => {
      setJobCompletedDate(job_completed_at);

      if (!isSubStatus || (isSubStatus && jobSubStatus) && job_completed_at) {
        const order = data.results[idx];
        const job = order.jobs[jobIdx];

      client.patch(`installer-jobs/${job.id}`, { job_completed_at, ...(isSubStatus ? { job_substatus: jobSubStatus} : {}) }).tap(() => {
        updateItem(idx, ['jobs', jobIdx, 'job_completed_at'], () => job_completed_at);
        if(isSubStatus) {
          updateItem(idx, ['jobs', jobIdx, 'job_substatus'], () => jobSubStatus);
          NotificationManager.success('Completed date and substatus updated');
        } else {
          NotificationManager.success('Completed date updated');
        }
      });
      setIsCompletedDateModalOpen(false);
      setJobSubStatus(null);
      setJobCompletedDate(null);
    }
    }
  }),
  withHandlers({
    onStatusChange: ({ 
      client, 
      data, 
      updateItem, 
      toggleBookedDateModal, 
      toggleCompletedDateModal, 
      toggleSubStatusModal,
      setJobStatus, 
      setIdx, 
      setJobIdx, 
      setAppointmentDate, 
      setJobCompletedAt, 
      setIsSubStatus, 
      jobSubStatuses, 
      setJobSubStatusOptions,
      isSubStatus
    }) => (
      idx,
      jobIdx,
      job_status
    ) => {
      const order = data.results[idx];
      const job = order.jobs[jobIdx];
      let showSubStatusModel = false;
      setJobStatus(job_status);
      setIdx(idx);
      setJobIdx(jobIdx);
      setAppointmentDate(job.appointment_date);
      setJobCompletedAt(job.job_completed_at);
        
      if ([26, 42, 50, 51, 52, 80].includes(job_status)) {
        showSubStatusModel = true;
        setIsSubStatus(true);
        const subStatuses = _.get(_.find(jobSubStatuses, (obj) => obj.type.value == job_status), 'subStatuses', []);
        setJobSubStatusOptions(subStatuses);
      } else {
        setIsSubStatus(false);
      }

      if ([40, 41, 76, 78].includes(job_status)) {
        toggleBookedDateModal();
      } else if (job_status < 50 && showSubStatusModel) {
        toggleSubStatusModal();
      }

      if ([50, 51, 52, 70, 71, 77, 79, 80].includes(job_status)) {
        toggleCompletedDateModal();
      }

      client.patch(`installer-jobs/${job.id}`, { job_status }).tap(() => {
        updateItem(idx, ['jobs', jobIdx, 'job_status'], () => job_status);
        NotificationManager.success('Status updated');
      });
    },
    toggleCollapse: ({ openItem, setOpenItem, setSaveEnabled }) => item => {
      if (openItem === item) setOpenItem(null);
      else setOpenItem(item);
      setSaveEnabled(false);
    },
  }),
  withHandlers({
    onJobSubStatusChange: ({ 
      setJobSubStatus,
      jobCompletedDate,
      setIsCompletedDateModalOpen,
      client,
      updateItem,
      data,
      idx,
      jobIdx,
      isSubStatus,
      setIsSubStatusModalOpen,
      isCompletedDateModalOpen,
      setJobCompletedDate
    }) => (event) => {
      const order = data.results[idx];
      const job = order.jobs[jobIdx];
      const {value} = event.target;
      setJobSubStatus(value)
      if(isSubStatus && value && isCompletedDateModalOpen && jobCompletedDate) {

        client.patch(`installer-jobs/${job.id}`, { 
          job_completed_at: jobCompletedDate,
          job_substatus: value,
        }).tap(() => {
          updateItem(idx, ['jobs', jobIdx, 'job_completed_at'], () => jobCompletedDate);
          updateItem(idx, ['jobs', jobIdx, 'job_substatus'], () => value);
          NotificationManager.success('Completed date and substatus updated');
        });
        setIsCompletedDateModalOpen(false);
        setJobSubStatus(null);
        setJobCompletedDate(null);
      } else if (isSubStatus && value && !isCompletedDateModalOpen) {
        client.patch(`installer-jobs/${job.id}`, { 
          job_substatus: value,
        }).tap(() => {
          updateItem(idx, ['jobs', jobIdx, 'job_substatus'], () => value);
          NotificationManager.success('Substatus updated');
        });
        setIsSubStatusModalOpen(false);
        setJobSubStatus(null);
      }
    },
  }),
  withResolver(
    {
      rejectionReasons: () => client =>
        client.get(
          'options?rejection_reasons'
        ),
    },
    {
      onResolved: ({setRejectionReasons}) => ({ rejectionReasons }) => {
        setRejectionReasons(rejectionReasons.rejection_reasons);
      }
    }
  ),
  withResolver(
    {
      jobSubStatus: () => client => client.get('job_substatuses'),
    },
    {
      onResolved: ({setJobSubStatuses }) => ({ jobSubStatus }) => {
        setJobSubStatuses(jobSubStatus);
      },
    }
  ),
  withState('page', 'setPage', 0),
  withPropsOnChange(['data', 'limit'], ({data, limit}) => {
    return {data, limit, pages: range(1, Math.ceil(data.count / limit) + 1)}
  }),
  withHandlers({
    toggleCollapse: ({ openItem, setOpenItem }) => item => {
      if (openItem === item) setOpenItem(null);
      else setOpenItem(item);
    },
    onDoAll: ({
      setRejectAllPending,
      setAcceptAllPending,
      data,
      acceptReject,
      client,
      reason,
      updateResults,
      setIsModalOpen,
    }) => () => {
      if(acceptReject === 'reject')
        setRejectAllPending(true);
      else
        setAcceptAllPending(true);
      const failed = [];

      Promise.mapSeries(data.results, item =>
        client
          .post(`/installer-orders/${item.id}/${acceptReject}?order_status=new`, {
            rejection: parseInt(reason),
            comments: '',
          })
          .catch(err => failed.push(item))
      ).finally(() => {
        if (failed.length) {
          NotificationManager.error(`Could not ${acceptReject} ${failed.length} orders`);
        } else {
          NotificationManager.success(`Orders ${acceptReject}ed`);
        }
        if(acceptReject === 'reject')
          setRejectAllPending(false);
        else
          setAcceptAllPending(false);
        setIsModalOpen(false);
        updateResults(failed);
      });
    },
  }),
  withPropsOnChange(['tempFilters'], ({ tempFilters, setJobSubStatusesFilter, jobSubStatuses }) => {
    const statusFilter = Object.keys(tempFilters).filter(key => key.startsWith('status'));
    const statuses = statusFilter.map(key => tempFilters[key]);
    const subStatuses = jobSubStatuses.filter(i => statuses.includes(i.type.value)).map(i => i.subStatuses).flat();
    setJobSubStatusesFilter(subStatuses);
}),
);

export default enhance(List);



// WEBPACK FOOTER //
// ./src/pages/InstallerOrders/List.js